import { useQuery } from "react-query";
import { Theme_Preferences } from "../../utils/constants";
import { getThemePreferencesProperties } from "./ThemePreferenceProperties";

export const useThemePreferencesProperties = () =>
  useQuery([Theme_Preferences], () => getThemePreferencesProperties(), {
    // A ausência de preferências é uma resposta de erro legítima: sem
    // `retry: false` o `FullPageLoader` do `ThemeProvider` ficava visível
    // durante 3 tentativas antes de a aplicação assumir o tema por omissão.
    retry: false,
    refetchOnWindowFocus: false,
  });
